import { AD_UNIT_CODE } from '../define'

let anchorSlotRight = null
let anchorSlotLeft = null

export const createAnchorAds = () => {
  googletag.cmd.push(() => {
    anchorSlotLeft = googletag.defineOutOfPageSlot(
      `/${window.pageInfo['ads']['gamConfig']['adsAccount']}/${AD_UNIT_CODE}/anchor_left`,
      googletag.enums.OutOfPageFormat.LEFT_SIDE_RAIL
    )
    if (anchorSlotLeft) {
      anchorSlotLeft.addService(googletag.pubads())
    }

    anchorSlotRight = googletag.defineOutOfPageSlot(
      `/${window.pageInfo['ads']['gamConfig']['adsAccount']}/${AD_UNIT_CODE}/anchor_right`,
      googletag.enums.OutOfPageFormat.RIGHT_SIDE_RAIL
    )
    if (anchorSlotRight) {
      anchorSlotRight.addService(googletag.pubads())
    }
  })
}

export const displayAnchorAds = () => {
  if (anchorSlotLeft) {
    googletag.cmd.push(() => {
      googletag.display(anchorSlotLeft)
    })
  }
  if (anchorSlotRight) {
    googletag.cmd.push(() => {
      googletag.display(anchorSlotRight)
    })
  }
}
